import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Cookies from 'js-cookie'

// 配置 axios 基础 URL
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || '/api'

// 将后端 URL 挂载到 Vue 原型，供组件使用
Vue.prototype.$backendUrl = process.env.VUE_APP_BACKEND_URL || window.location.origin

// 请求拦截器，添加 token
axios.interceptors.request.use(config => {
  const token = Cookies.get('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器，处理错误
axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    // 清除 token 并跳转到登录页
    Cookies.remove('token')
    router.replace('/login')
  }
  return Promise.reject(error)
})

Vue.prototype.$axios = axios
Vue.prototype.$cookies = Cookies

// 添加全局权限检查方法
Vue.prototype.$canWrite = function() {
  return this.$store.getters.canWrite
}

Vue.prototype.$isReadOnly = function() {
  return this.$store.getters.isReadOnly
}

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
